<template>
    <div class="row">
        <div class="w-100">
            <div id="panel-1" class="panel mt-1 m-2">
                <div class=" mr-5 mt-4 d-flex align-items-center justify-content-end">
                    <el-dropdown @command="handleDropdownCommand">
                        <el-button type="primary" size="mini">
                            Hành động<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-if="[4,5,6].includes(keyAccount)" command="average_sale">Doanh số trung bình</el-dropdown-item>
                            <el-dropdown-item v-if="[3,4,5,6].includes(keyAccount)" command="sales_no_revenue">Sale không có doanh số</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <section class="m-4">
                    <div class="filters">
                        <el-row :gutter="10" class="w-100">
                            <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5"
                                v-if="[7, 6].includes(keyAccount) || [295391, 266029].includes(currentUser.id)"
                            >
                                <el-select
                                    v-model="form.area_id"
                                    placeholder="Chọn Khu vực"
                                    filterable
                                    collapse-tags
                                    clearable
                                    class="w-100 mt-3"
                                    @change="querySever(); getCenter()"
                                >
                                    <el-option v-for="item in areas" :key="item.id" :label="item.name" :value="item.id" />
                                </el-select>
                            </el-col>

                            <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5" v-if="[5, 6, 7].includes(keyAccount)">
                                <el-select
                                    v-model="form.branch_id"
                                    placeholder="Chọn văn phòng"
                                    filterable
                                    clearable
                                    class="w-100 mt-3"
                                    @change="querySever(); getChildUser(form.branch_id)"
                                >
                                    <el-option
                                        v-for="item in branches"
                                        :key="item.id"
                                        :label="item.name_alias || item.name"
                                        :value="item.id"
                                    />
                                </el-select>
                            </el-col>

                            <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5">
                                <tree-select
                                    v-model="cache_sale"
                                    :normalizer="normalizer"
                                    :options="options"
                                    :show-count="true"
                                    class="w-100 mt-3"
                                    placeholder="Chọn nhân sự muốn xem..."
                                    search-nested
                                    @input="handleChangeSale"
                                >
                                    <!--eslint-disable-->
                                    <label
                                        slot="option-label"
                                        slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }"
                                        :class="labelClassName"
                                    >
                                        <img :src="publicPath + getImageHierarchy(node.raw.profile.account_type.id)" alt="" />
                                        <span> {{ node.label }} - {{ node.raw.id + 100000 }}</span>
                                        <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
                                    </label>
                                </tree-select>
                            </el-col>

                            <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="4">
                                <el-select v-model="form.account_type_id" placeholder="Chọn chức vụ" clearable class="w-100 mt-3"  @change="querySever();">
                                    <el-option v-for="item in filteredPositions" :key="item.id" :label="item.name" :value="item.id" />
                                </el-select>
                            </el-col>

                            <el-col :xs="24" class="mt-3" :sm="12" :md="8" :lg="4" :xl="3">
                                <el-date-picker
                                    v-model="form.dateRange"
                                    class="w-100"
                                    type="daterange"
                                    value-format="yyyy-MM-dd"
                                    start-placeholder="Từ ngày"
                                    end-placeholder="đến ngày"
                                    @change="querySever"
                                />
                            </el-col>

                            <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="4">
                                <el-select v-model="form.mechanism" clearable placeholder="Chọn cơ chế lương" size="small" class="w-100 mt-3" @change="querySever">
                                    <el-option v-for="item in mechanisms" :key="item.id" :label="item.name" :value="item.id" />
                                </el-select>
                            </el-col>

                            <el-col :lg="4" :md="8" :sm="12" :xl="3" :xs="24">
                                <el-select v-model="form.view_as" class="w-100 mt-3" clearable placeholder="Chọn tư cách để xem" @change="querySever">
                                    <el-option v-for="item in watchAs" :key="item.id" :label="item.value" :value="item.id">
                                        <span style="float: left">{{ item.value }}</span>
                                    </el-option>
                                </el-select>
                            </el-col>

                            <el-col :lg="4" :md="8" :sm="12" :xl="3" :xs="24">
                                <el-select v-model="form.active" class="w-100 mt-3" placeholder="Chọn trạng thái nhân sự" @change="querySever">
                                    <el-option v-for="item in actives" :key="item.id" :label="item.value" :value="item.id">
                                        <span style="float: left">{{ item.value }}</span>
                                    </el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                    </div>

                    <div class="w-100">
                        <div class="tools-right mb-2">
                            <div style="font-weight: 600; cursor: pointer" @click="dialogColumnsVisible = true">
                                <i class="el-icon-setting"></i>
                                <span class="ml-1">Hiển thị</span>
                            </div>
                        </div>

                        <div class="table-scroll">
                            <table class="personnel-table w-100">
                                <thead>
                                <tr>
                                    <th
                                        v-for="col in tableHeadColsNormal"
                                        :key="col.key"
                                        :rowspan="hasTenure ? 2 : 1"
                                        :class="col.thClass"
                                    >
                                        <template v-if="col.key === 'conversion'">
                                            <el-select
                                                class="conversion_rate w-100"
                                                v-model="conversionSelected"
                                                size="mini"
                                                placeholder="Tỷ lệ chuyển đổi"
                                                @change="recalculateConversion"
                                            >
                                                <el-option
                                                    v-for="item in conversionOptions"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value"
                                                />
                                            </el-select>
                                        </template>
                                        <template v-else>
                                            {{ col.label }}
                                        </template>
                                    </th>
                                    <th
                                        v-if="hasTenure"
                                        key="tenure-group"
                                        :colspan="tenureChildren.length"
                                        class="th-yellow"
                                    >
                                        Thâm niên làm việc
                                    </th>
                                </tr>

                                <tr v-if="hasTenure">
                                    <th v-for="c in tenureChildren" :key="c.key" class="th-yellow">
                                        {{ c.label }}
                                    </th>
                                </tr>
                                </thead>

                                <tbody v-loading="loading">
                                <tr v-for="row in dataTable" :key="row.id">
                                    <td v-for="col in tableBodyColsNormal" :key="col.key">
                                        {{ formatCell(row, col) }}
                                    </td>

                                    <template v-if="hasTenure">
                                        <td v-for="c in tenureChildren" :key="c.key">
                                            {{ formatCell(row, c) }}
                                        </td>
                                    </template>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="mt-3 d-flex justify-content-end">
                            <b>Tổng số bản ghi: <span style="color: #26A0FC">{{ paging.total }}</span></b>
                        </div>
                    </div>

                    <div class="edutalk-paging">
                        <div class="block">
                            <el-pagination
                                background
                                @current-change="handleCurrentChange"
                                :current-page.sync="paging.current_page"
                                :page-size="paging.per_page"
                                layout="prev, pager, next"
                                :total="paging.total"
                            />
                        </div>
                    </div>
                </section>
            </div>
        </div>

        <!-- Dialog Hiển thị cột -->
        <el-dialog title="Hiển thị cột" class="dialogSetting" :visible.sync="dialogColumnsVisible" width="800px">
            <div class="pb-4">
                <hr />
                <div>
                    <el-checkbox
                        :indeterminate="isIndeterminate"
                        size="medium"
                        class="mb-2"
                        v-model="checkAll"
                        @change="handleCheckAllChange"
                    >
                        Chọn tất cả
                    </el-checkbox>
                </div>

                <el-row :gutter="20">
                    <el-checkbox-group size="medium" v-model="checkedKeys" @change="handleCheckedKeysChange">
                        <el-col :span="6" class="my-2 fa-2x" v-for="col in dialogCols" :key="col.key">
                            <el-checkbox :label="col.key" :disabled="col.key === 'name'">
                                {{ col.label }}
                                <span v-if="col.key === 'name'" class="text-muted" style="font-size: 12px"> (bắt buộc)</span>
                            </el-checkbox>
                        </el-col>
                    </el-checkbox-group>
                </el-row>

                <div class="d-flex justify-content-between mt-3">
                    <el-button type="text" @click="resetToSnapshot" :disabled="!dirty">Hoàn tác thay đổi</el-button>
                    <div>
                        <el-button @click="dialogColumnsVisible = false" plain>Đóng</el-button>
                        <el-button type="primary" :loading="loadingSave" :disabled="!dirty" @click="saveColumnsConfig">
                            {{ isUpdateTableColumnsOption ? 'Sửa thông tin' : 'Lưu thông tin' }}
                        </el-button>
                    </div>
                </div>
            </div>
        </el-dialog>

        <el-dialog
            :visible.sync="dialogSaleNoRevenueVisible"
            width="70%"
            top="6vh"
            append-to-body
            title="Danh sách sales không doanh số"
            custom-class="sale-no-revenue-dialog"
            :close-on-click-modal="false"
            :show-close="false"
        >
        <dialog-sale-no-revenue @close="dialogSaleNoRevenueVisible=false" :is_show="dialogSaleNoRevenueVisible"></dialog-sale-no-revenue>
        </el-dialog>

        <el-dialog title="Doanh số trung bình" :visible.sync="salesAverageDialog" width="70%">
              <average-sale :is_show="salesAverageDialog"></average-sale>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ChartDonut from "../approve-team-level/components/chart/ChartDonut.vue";
import WarningPanel from "../approve-team-level/components/warning/WarningPanel.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SERVICE_CONFIG_CUSTOMER_GET, SERVICE_CONFIG_CUSTOMER_STORE } from "@/core/services/store/service.module";
import { GET_CHILD_USER, BRANCH_LIST } from "@/core/services/store/service.module";
import { GET_REGIONS_BY_USER } from "@/core/services/store/customer/customer.module";
import { GET_LIST_PERSONNEL_EFFICIENCY, GET_LIST_SALE_NO_REVENUE } from "@/core/services/store/user/users.module";
import AverageSale from "./component/AverageSales.vue";
import DialogSaleNoRevenue from "./component/dialogSaleNoRevenue.vue";

const TABLE_COLS = [
    { key: 'id', label: 'Mã nhân sự', thClass: 'th-purple', get: r => r.id },
    { key: 'name', label: 'Họ tên', thClass: 'th-purple', get: r => r.name },
    { key: 'position', label: 'Vị trí', thClass: 'th-purple', get: r => r.position },
    { key: 'status', label: 'Trạng thái', thClass: 'th-purple', get: r => r.status },
    { key: 'salary_mechanism', label: 'Cơ chế lương', thClass: 'th-purple', get: r => r.salary_mechanism },
    { key: 'start_to_work', label: 'Ngày bắt đầu làm', thClass: 'th-purple', format: 'date', get: r => r.start_to_work },
    { key: 'thoi_gian_nghi_viec', label: 'Ngày nghỉ việc', thClass: 'th-purple', format: 'date', get: r => r.thoi_gian_nghi_viec },
    {
        key: 'tenure',
        type: 'group',
        label: 'Thâm niên làm việc',
        thClass: 'th-yellow',
        children: [
            { key: 'seniority_day', label: 'Ngày', get: r => r.seniority_day },
            { key: 'seniority_month', label: 'Tháng', get: r => r.seniority_month },
            { key: 'seniority_year', label: 'Năm', get: r => r.seniority_year },
        ],
    },

    { key: 'best_customer', label: 'Số khách hàng (tiềm năng)', thClass: 'th-yellow', get: r => r.customer_level?.one_a ?? 0 },
    { key: 'schedules', label: 'Số lịch hẹn tư vấn', thClass: 'th-yellow', get: r => r.customer_level?.two_a ?? 0 },
    { key: 'register_customer', label: 'Số KH đăng ký', thClass: 'th-yellow', get: r => r.customer_level?.three_b ?? 0 },
    { key: 'contracts', label: 'Số hợp đồng', thClass: 'th-yellow', get: r => r.customer_level?.four_a ?? 0 },
    { key: 'customer_count', label: 'Số khách hàng', thClass: 'th-yellow', get: r => r.customer_count ?? 0 },
    { key: 'sales_persional', label: 'Doanh số cá nhân', thClass: 'th-yellow', format: 'money', get: r => r.sales ?? 0 },
    { key: 'sales_team', label: 'Doanh số đội', thClass: 'th-yellow', format: 'money', get: r => r.sales_team ?? 0 },

    { key: 'conversion', label: 'Tỷ lệ chuyển đổi', thClass: 'th-yellow', get: r => `${r.conversion_rate ?? 0} %` },
]

export default {
    name: 'personnelEfficiency',
    components: {DialogSaleNoRevenue, ChartDonut, WarningPanel, AverageSale },

    data () {
        return {
            publicPath: process.env.VUE_APP_BASE_URL,

            tableCols: TABLE_COLS,

            years: [],
            cache_sale: null,
            table: { rows: [] },

            branches: [],
            areas: [],
            childUsers: [],

            form: {
                branch_id: '',
                area_id: '',
                dateRange: [],
                sale: '',
                view_as: 2,
                account_type_id: '',
                active: 1,
            },

            loading: false,
            _debounceTimer: null,

            positions: [
                { id: 1, name: 'Sales Leader' },
                { id: 2, name: 'Sales Expert' },
                { id: 3, name: 'Sales' },
                { id: 4, name: 'Sales Intern' },
                { id: 5, name: 'Giám đốc văn phòng' },
                { id: 6, name: 'Giám đốc khu vực' },
                { id: 26, name: 'Giám đốc vùng' },
                { id: 'ctv', name: 'Cộng tác viên' },
            ],

            keyAccountMap: {
                7: [26, 6, 5, 1, 2, 3, 4], // BOD
                6: [6, 5, 1, 2, 3, 4, 26], // Giám đốc vùng
                5: [5, 1, 2, 3, 4, 6], // Giám đốc khu vực
                4: [1, 2, 3, 4, 5], // Giám đốc văn phòng
                3: [1, 2, 3, 4], // Sales Leader
            },

            paging: { current_page: 1, per_page: 10, total: 0 },
            accountTypeMap: { 32: [32, 34], 16: [32, 16, 34] },

            mechanisms: [
                { id: 1, name: 'Lương cứng' },
                { id: 2, name: 'Lương mềm' },
                { id: 3, name: 'Lương cứng theo bậc' },
                { id: 4, name: 'Lương cứng cố định' },
                { id: 5, name: 'Lương cứng partime' },
            ],

            showWarning: false,

            dialogColumnsVisible: false,
            isUpdateTableColumnsOption: false,
            loadingSave: false,
            salesAverageDialog: false,
            dialogSaleNoRevenueVisible: false,
            checkAll: false,
            isIndeterminate: false,
            checkedKeys: [],

            options: [],
            dataTable: [],
            snapshotColumns: null,
            loadingSaleNoRevenue: false,
            _syncingRoute: false,
            _syncingState: false,

            tableColumnsOptionDefault: {
                id: true,
                name: true,
                position: true,
                status: true,
                salary_mechanism: true,
                start_to_work: true,
                thoi_gian_nghi_viec: true,
                tenure: true,

                best_customer: true,
                schedules: true,
                register_customer: true,
                contracts: true,
                customer_count: true,
                sales_persional: true,
                sales_team: true,
                conversion: true,
            },
            tableColumnsOption: {},

            imageHierarchy: {
                '5': 'media/hierarchy/gdvp.png',
                '1': 'media/hierarchy/sl.png',
                '2': 'media/hierarchy/se.png',
                '3': 'media/hierarchy/s.png',
                '4': 'media/hierarchy/si.png'
            },

            watchAs: [
                { id: 1, value: 'Đội kinh doanh', label: 'Đội' },
                { id: 2, value: 'Cá nhân', label: 'Cá nhân' }
            ],

            actives: [
                { id: 1, value: 'Hoạt động', label: 'Hoạt động' },
                { id: 2, value: 'Nghỉ việc', label: 'Nghỉ' }
            ],

            conversionSelected: 'Tỷ lệ chuyển đổi',
            conversionOptions: [
                { value: 'nc_lhtv', label: 'Nhu cầu → Có lịch hẹn tv' },
                { value: 'lhtv_khd', label: 'Có lịch hẹn tv → KH đến' },
                { value: 'tlc', label: 'Tỷ lệ chốt' },
                // { value: 'khtn_hd', label: 'Khtn -> hợp đồng' },
            ],
        }
    },

    computed: {
        ...mapGetters(['currentUser', 'keyAccount']),

        filteredPositions () {
            if (!this.keyAccount) return this.positions
            const ids = this.keyAccountMap[this.keyAccount] || []
            const list = this.positions.filter(p => ids.includes(p.id))
            const ctv = this.positions.find(p => p.id === 'ctv')
            if (ctv && !list.some(p => p.id === 'ctv')) list.push(ctv)
            return list
        },

        dialogCols () {
            return this.tableCols.map(c => ({ key: c.key, label: c.label }))
        },

        allColumnKeys () {
            return this.dialogCols.map(c => c.key)
        },

        dirty () {
            return JSON.stringify(this.tableColumnsOption) !== JSON.stringify(this.snapshotColumns)
        },

        hasTenure () {
            return !!this.tableColumnsOption?.tenure
        },

        tenureChildren () {
            const g = this.tableCols.find(c => c.key === 'tenure')
            return g?.children || []
        },

        tableHeadColsNormal () {
            return this.tableCols.filter(c => {
                if (c.type === 'group') return false

                if (this.form.view_as === 1 && c.key === 'sales_persional') return false

                return !!this.tableColumnsOption?.[c.key]
            })
        },

        tableBodyColsNormal () {
            return this.tableHeadColsNormal
        },
    },

    mounted () {
        this.initYears()
        this.$store.dispatch(SET_BREADCRUMB, [{ title: "Hiệu quả nhân sự", icon: "fas fa-list" }])

        this.getColumnsConfig()
        this.getCenter()
        this.getRegions()
        this.getChildUser()
    },

    watch: {
        '$route.query': {
            immediate: true,
            handler(q) {
                if (this._syncingState) return
                this._syncingRoute = true
                this.applyQueryToState(q)
                this._syncingRoute = false
                this.querySever()
            }
        },

        form: {
            deep: true,
            handler() {
                if (this._syncingRoute) return

                this.paging.current_page = 1

                if (this._debounceTimer) clearTimeout(this._debounceTimer)
                this._debounceTimer = setTimeout(() => {
                    this.syncStateToRoute()
                }, 300)
            }
        },

        'paging.current_page'(page) {
            if (this._syncingRoute) return
            this.syncStateToRoute()
        }
    },

    methods: {
        normalizeSavedConfig (saved) {
            if (!saved) return null
            if (typeof saved === 'object') return saved
            if (typeof saved === 'string') {
                try { return JSON.parse(saved) } catch (e) { return null }
            }
            return null
        },

        async getColumnsConfig () {
            try {
                const res = await this.$store.dispatch(SERVICE_CONFIG_CUSTOMER_GET, {
                    config_type: '4',
                    model: 'user'
                })

                const rawSaved = res?.data?.[4]
                const saved = this.normalizeSavedConfig(rawSaved)

                this.tableColumnsOption = saved
                    ? { ...this.tableColumnsOptionDefault, ...saved }
                    : { ...this.tableColumnsOptionDefault }

                this.tableColumnsOption.name = true

                this.checkedKeys = this.allColumnKeys.filter(k => !!this.tableColumnsOption[k])
                if (!this.checkedKeys.includes('name')) this.checkedKeys.unshift('name')
                this.checkedKeys = Array.from(new Set(this.checkedKeys))

                this.syncCheckAllState()
                this.snapshotColumns = JSON.parse(JSON.stringify(this.tableColumnsOption))
                this.isUpdateTableColumnsOption = !!saved
            } catch (e) {
                this.tableColumnsOption = { ...this.tableColumnsOptionDefault }
                this.tableColumnsOption.name = true

                this.checkedKeys = this.allColumnKeys.filter(k => !!this.tableColumnsOption[k])
                if (!this.checkedKeys.includes('name')) this.checkedKeys.unshift('name')
                this.checkedKeys = Array.from(new Set(this.checkedKeys))

                this.syncCheckAllState()
                this.snapshotColumns = JSON.parse(JSON.stringify(this.tableColumnsOption))
            }
        },

        async saveColumnsConfig () {
            try {
                this.loadingSave = true
                const payload = { ...this.tableColumnsOption, name: true }
                await this.$store.dispatch(SERVICE_CONFIG_CUSTOMER_STORE, {
                    detail: payload,
                    config_type: 4,
                    model: 'user'
                })
                this.snapshotColumns = JSON.parse(JSON.stringify(this.tableColumnsOption))
                this.isUpdateTableColumnsOption = true
                this.$message.success('Lưu cấu hình thành công')
                this.dialogColumnsVisible = false
            } finally {
                this.loadingSave = false
            }
        },

        handleCheckAllChange (val) {
            this.checkedKeys = val ? [...this.allColumnKeys] : ['name']
            this.checkedKeys = Array.from(new Set(this.checkedKeys))
            this.applyCheckedKeys()
            this.syncCheckAllState()
        },

        handleCheckedKeysChange () {
            if (!this.checkedKeys.includes('name')) this.checkedKeys.unshift('name')
            this.checkedKeys = Array.from(new Set(this.checkedKeys))
            this.applyCheckedKeys()
            this.syncCheckAllState()
        },

        applyCheckedKeys () {
            this.allColumnKeys.forEach(k => {
                this.tableColumnsOption[k] = this.checkedKeys.includes(k)
            })
            this.tableColumnsOption.name = true
        },

        syncCheckAllState () {
            const total = this.allColumnKeys.length
            const checked = this.checkedKeys.length
            this.checkAll = checked === total
            this.isIndeterminate = checked > 0 && checked < total
        },

        resetToSnapshot () {
            this.tableColumnsOption = JSON.parse(JSON.stringify(this.snapshotColumns))
            this.checkedKeys = this.allColumnKeys.filter(k => !!this.tableColumnsOption[k])
            if (!this.checkedKeys.includes('name')) this.checkedKeys.unshift('name')
            this.checkedKeys = Array.from(new Set(this.checkedKeys))
            this.syncCheckAllState()
        },

        formatCell (row, col) {
            const val = col.get ? col.get(row) : row[col.key]
            if (col.format === 'date') {
                const f = this.$options.filters?.formatDate
                return f ? f(val) : (val ?? '')
            }
            if (col.format === 'money') {
                const f = this.$options.filters?.formatVND
                return f ? f(val) : (val ?? 0)
            }
            return val ?? ''
        },

        getImageHierarchy (account_type) {
            return this.imageHierarchy[account_type]
        },

        handleChangeSale () {
            this.form.sale = this.cache_sale
            if (!this.form.sale) this.form.view_as = ''
            this.querySever()
        },

        normalizer (node) {
            return { id: node.id, label: node.name }
        },

        toggleWarning () {
            this.showWarning = !this.showWarning
        },

        getCenter () {
            const payload = { area_id: this.form.area_id }
            this.$store.dispatch(BRANCH_LIST, payload).then((response) => {
                if (response.status === 422) {
                    this.$message({ type: 'warning', message: `${response.message}`, showClose: true })
                } else {
                    this.branches = response.data
                }
            })
        },

        getRegions () {
            const payload = { all: this.keyAccount === 7 ? 1 : 0 }
            this.$store.dispatch(GET_REGIONS_BY_USER, payload).then((response) => {
                if (response.status === 422) {
                    this.$message({ type: 'warning', message: `${response.message}`, showClose: true })
                } else {
                    this.areas = response.data
                }
            })
        },

        getChildUser () {
            let branchId = ''
            if ([1, 5].includes(this.currentUser.account_type.id)) {
                branchId = this.currentUser.profile.chi_nhanh_id
            }
            const payload = { branch_id: this.form.branch_id || branchId }
            this.$store.dispatch(GET_CHILD_USER, payload).then((response) => {
                if (response.status === 422) {
                    this.$message({ type: 'warning', message: `${response.message}`, showClose: true })
                } else {
                    this.childUsers = response.data
                    this.options = response.data
                }
            })
        },

        async querySever () {
            this.loading = true
            try {
                const payload = {
                    page: this.paging.current_page,
                    per_page: this.paging.per_page,
                    branch_id: this.form.branch_id,
                    area_id: this.form.area_id,
                    account_type_id: this.form.account_type_id,
                    mechanism: this.form.mechanism,
                    sale: this.form.sale,
                    date_range: this.form.dateRange,
                    view_as: this.form.view_as,
                    active: this.form.active,
                }
                const response = await this.$store.dispatch(GET_LIST_PERSONNEL_EFFICIENCY, payload)

                this.dataTable = response?.data ?? []
                this.paging = response?.pagination ?? this.paging
                this.recalculateConversion()
            } finally {
                this.loading = false
            }
        },

        syncStateToRoute() {
            const nextQuery = this.buildQueryFromState()
            const currQuery = this.$route.query || {}

            if (this.isSameQuery(currQuery, nextQuery)) return

            this._syncingState = true
            this.$router.replace({ query: nextQuery }).finally(() => {
                this._syncingState = false
            })
        },

        handleCurrentChange(page) {
            this.paging.current_page = page
        },

        initYears () {
            const y = new Date().getFullYear()
            const s = 2023
            this.years = Array.from({ length: y - s + 1 }, (_, i) => s + i)
        },

        fmtYMD (d) {
            const y = d.getFullYear()
            const m = String(d.getMonth() + 1).padStart(2, '0')
            const day = String(d.getDate()).padStart(2, '0')
            return `${y}-${m}-${day}`
        },

        getThisMonthRange () {
            const now = new Date()
            const start = new Date(now.getFullYear(), now.getMonth(), 1)
            const end = new Date(now.getFullYear(), now.getMonth() + 1, 0)
            return [this.fmtYMD(start), this.fmtYMD(end)]
        },

        recalculateConversion () {
            const mode = this.conversionSelected

            this.dataTable = (this.dataTable || []).map(row => {
                const logs = Array.isArray(row.customer_level_log)
                    ? row.customer_level_log
                    : (row.customer_level_log ? [row.customer_level_log] : [])

                const denom = row.customer_level_count

                let num = 0
                if (mode === 'nc_lhtv') {
                    num = logs.filter(x => x?.old_level === '1A' && x?.new_level === '2A').length
                }

                if (mode === 'lhtv_khd') {
                    num = logs.filter(x => x?.old_level === '2A' && x?.new_level === '3B').length
                }

                if (mode === 'tlc') {
                    num = logs.filter(x => x?.new_level === '3A').length
                }

                if (mode === 'khtn_hd') {
                    num = logs.filter(x => x?.old_level === '3A' && x?.new_level === '4A').length
                }

                const rate = denom > 0 ? (num / denom) * 100 : 0
                return { ...row, conversion_rate: rate.toFixed(2) }
            })
        },

        handleDropdownCommand(command) {
            if (command === 'average_sale') {
                this.salesAverageDialog = true;
            }

            if (command === 'sales_no_revenue') {
                this.dialogSaleNoRevenueVisible = true;
            }
        },

        toInt(v) {
            if (v === '' || v === null || v === undefined) return ''
            const n = Number(v)
            return Number.isFinite(n) ? n : ''
        },

        toStr(v) {
            if (v === null || v === undefined) return ''
            return String(v)
        },

        applyQueryToState(q = {}) {
            this.form.area_id = this.toInt(q.area_id)
            this.form.branch_id = this.toInt(q.branch_id)
            this.form.sale = this.toInt(q.sale)
            this.cache_sale = this.form.sale || null

            this.form.account_type_id = this.toInt(q.account_type_id)
            this.form.mechanism = this.toInt(q.mechanism)
            this.form.view_as = q.view_as !== undefined ? this.toInt(q.view_as) : this.form.view_as
            this.form.active = q.active !== undefined ? this.toInt(q.active) : this.form.active

            const from = q.from ? this.toStr(q.from) : ''
            const to = q.to ? this.toStr(q.to) : ''
            this.form.dateRange = (from && to) ? [from, to] : this.getThisMonthRange()

            this.paging.current_page = q.page ? Number(q.page) : 1
        },

        buildQueryFromState() {
            const q = {
                area_id: this.form.area_id || undefined,
                branch_id: this.form.branch_id || undefined,
                sale: this.form.sale || undefined,
                account_type_id: this.form.account_type_id || undefined,
                mechanism: this.form.mechanism || undefined,
                view_as: this.form.view_as || undefined,
                active: this.form.active || undefined,
                from: this.form.dateRange?.[0] || undefined,
                to: this.form.dateRange?.[1] || undefined,
                page: this.paging.current_page || 1,
            }

            Object.keys(q).forEach(k => q[k] === undefined && delete q[k])
            return q
        },

        isSameQuery(a = {}, b = {}) {
            const norm = (o) => {
                const x = { ...o }
                Object.keys(x).forEach(k => (x[k] === '' || x[k] === null || x[k] === undefined) && delete x[k])
                return Object.keys(x).sort().reduce((acc, k) => (acc[k] = x[k], acc), {})
            }
            return JSON.stringify(norm(a)) === JSON.stringify(norm(b))
        },
    }
}
</script>

<style lang="scss" scoped>
.hr-performance { width: 100%; }
.filters { margin-bottom: 12px; display: flex; align-items: center; flex-wrap: wrap; }
.filters .el-col { margin-bottom: 8px; }

.charts-row {
    display: grid; grid-template-columns: 1fr; gap: 16px; align-items: start;
    margin-bottom: 16px; width: 100%;
}
.chart-col { background: transparent; border: 0; padding: 0 12px; display: flex; flex-direction: column; align-items: center; }

.donut-skeleton { width: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 12px; padding: 8px 0; }
.donut-skeleton .circle { width: 220px; height: 220px; border-radius: 50%;
    background: linear-gradient(90deg, #f3f4f6 25%, #ede9fe 50%, #f3f4f6 75%); background-size: 400% 100%; animation: shimmer 1.2s ease-in-out infinite; }
.donut-skeleton .line { width: 60%; height: 14px; border-radius: 7px; background: linear-gradient(90deg, #f3f4f6 25%, #ede9fe 50%, #f3f4f6 75%); background-size: 400% 100%; animation: shimmer 1.2s ease-in-out infinite; }
@keyframes shimmer { 0% { background-position: 100% 0; } 100% { background-position: 0 0; } }

@media (min-width: 1024px) { .charts-row { grid-template-columns: 1fr 1fr; } }
@media (min-width: 1280px) { .charts-row { width: 66.67%; } }

.text-muted { color: #888; }

.tools-right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 14px;
}

.warning-inline { display: flex; align-items: center; }
.ring-icon {
    position: relative;
    cursor: pointer;
    width: 32px;
    height: 32px;
    display: flex; align-items: center; justify-content: center;
}
.ring-icon img { width: 100%; height: 100%; object-fit: contain; transform: rotate(15deg); transition: transform .3s ease; }
.ring-icon:hover img { transform: rotate(15deg) scale(1.1); }
.notification-badge {
    position: absolute; top: -4px; right: -4px;
    background: #ef4444; color: #fff; border-radius: 9999px;
    min-width: 18px; height: 18px; padding: 0 4px;
    display: flex; align-items: center; justify-content: center;
    font-size: 10px; font-weight: 700;
}

.table-scroll {
    width: 100%;
    overflow-x: auto;
    border: 1px solid #ddd;
    max-height: 520px;
    overflow-y: auto;
}

/* Hàng tiêu đề chính */
.personnel-table thead tr:first-child th {
    position: sticky;
    top: 0;
    z-index: 12;
}

/* Hàng tenure */
.personnel-table thead tr:nth-child(2) th {
    position: sticky;
    top: 42px;
    z-index: 11;
}

.personnel-table {
    width: max-content;
    border-collapse: collapse;
}

.personnel-table th,
.personnel-table td {
    padding: 10px;
    border: 1px solid #ccc;
    text-align: center;
    font-size: 13px;
}

.th-purple {
    background: #5d2f86;
    color: #fff;
    font-weight: 600;
}

.th-yellow {
    background: #f7e26f;
    color: #000;
    font-weight: 600;
}

th .conversion_rate {
    width: 100%;
    background: #f7e26f;
}

::v-deep .conversion_rate .el-input__inner {
    background-color: #f7e26f !important;
    border: none !important;
    box-shadow: none !important;
    color: #000 !important;
    font-weight: 600;
    height: 34px;
    line-height: 34px;
    padding: 0 20px 0 0;
    text-align: center;
}

::v-deep .conversion_rate .el-input__suffix { right: 6px; }
::v-deep .conversion_rate .el-input__suffix i { color: #b89e00 !important; font-size: 12px; }
::v-deep .conversion_rate .el-input__inner:hover { background-color: #f1e6a7 !important; }
::v-deep .conversion_rate .el-input__inner:focus { background-color: #f7e26f !important; border: none !important; box-shadow: none !important; }

::v-deep .el-select-dropdown__item.selected {
    background: #f7e26f55 !important;
    font-weight: 600;
    color: #000 !important;
}
::v-deep .el-select-dropdown__item:hover { background: #f7e26f33 !important; }
</style>

